import React, { Component } from "react";
import PropTypes from 'prop-types';
import PageTitle from "../Theme/PageTitle";
import { Button, Modal, Table } from "antd";
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';

import ApprovalFindContainer from './ApprovalFindContainer';

class ApprovalFindButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      widescreen: false,
      findApprovalModal: false
    }
  }

  componentDidMount = async () => {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();

    if (this.props.resourceCollection) {
      this.setDefaultAsResourceCollection();
    }
  }

  resize = () => {
    if (window.innerWidth >= 600) {
      this.setState({
        widescreen: true
      });
    } else {
      this.setState({
        widescreen: false
      });
    }
  }

  setDefaultAsResourceCollection = () => {

  }

  showModal = () => {
    this.setState({
      findApprovalModal: true,
    });
  }

  handleModalCancel = (e) => {
    this.setState({
      findApprovalModal: false,
    });
  }

  render() {
    return (
      <React.Fragment>
        {/* button goes here */}
        <Button id="find-approvals" onClick={this.showModal} style={{ marginBottom: 20, marginTop: 0 }} >Find Approvals</Button>
        <Modal
          zIndex={2000}
          title="Find Approvals"
          visible={this.state.findApprovalModal}
          onCancel={this.handleModalCancel} // the x in top right corner
          footer={[]}
        >
          <ApprovalFindContainer
            resourceCollection={this.props.resourceCollection}
          />
        </Modal>
      </React.Fragment>
    )
  }
}

ApprovalFindButton.propTypes = {
  user: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  selectedResource: PropTypes.object,
}

function mapStateToProps(state) {
  return {
    user: state.user,
    resources: state.resources,
    selectedResource: state.selectedResource,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ApprovalFindButton);


// WEBPACK FOOTER //
// ./src/Components/Approval/ApprovalFindButton.js